import adminHttpCommon from "../helper/adminHttpCommon";

const removeEmptyParams = (params) => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  );
};

export const fetchAdminStudentStats = () => {
  return adminHttpCommon.get("admin-dashboard/students/stats/");
};

export const fetchAdminStudentFilters = () => {
  return adminHttpCommon.get("admin-dashboard/students/filters/");
};

export const fetchAdminStudents = ({
  page = 1,
  pageSize = 20,
  search = "",
  filters = {},
}) => {
  return adminHttpCommon.get("admin-dashboard/students/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
      city: filters.city || "",
      board: filters.board || "",
      school: filters.school || "",
      student_class: filters.student_class || "",
    }),
  });
};

export const fetchAdminCounsellorStats = () => {
  return adminHttpCommon.get("admin-dashboard/counsellors/stats/");
};

export const fetchAdminCounsellors = ({ page = 1, pageSize = 20, search = "" }) => {
  return adminHttpCommon.get("admin-dashboard/counsellors/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
    }),
  });
};

export const createAdminCounsellor = (payload) => {
  return adminHttpCommon.post("admin-dashboard/counsellors/", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fetchAdminCounsellor = (counsellorId) => {
  return adminHttpCommon.get(`admin-dashboard/counsellors/${counsellorId}/`);
};

export const updateAdminCounsellor = (counsellorId, payload) => {
  return adminHttpCommon.patch(
    `admin-dashboard/counsellors/${counsellorId}/`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteAdminCounsellor = (counsellorId) => {
  return adminHttpCommon.delete(`admin-dashboard/counsellors/${counsellorId}/`);
};

export const fetchAdminSkillProviderStats = () => {
  return adminHttpCommon.get("admin-dashboard/skill-providers/stats/");
};

export const fetchAdminSkillProviders = ({
  page = 1,
  pageSize = 20,
  search = "",
}) => {
  return adminHttpCommon.get("admin-dashboard/skill-providers/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
    }),
  });
};

export const createAdminSkillProvider = (payload) => {
  return adminHttpCommon.post("admin-dashboard/skill-providers/", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fetchAdminSkillProvider = (skillProviderId) => {
  return adminHttpCommon.get(
    `admin-dashboard/skill-providers/${skillProviderId}/`
  );
};

export const updateAdminSkillProvider = (skillProviderId, payload) => {
  return adminHttpCommon.patch(
    `admin-dashboard/skill-providers/${skillProviderId}/`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteAdminSkillProvider = (skillProviderId) => {
  return adminHttpCommon.delete(
    `admin-dashboard/skill-providers/${skillProviderId}/`
  );
};

export const fetchAdminFranchiseStats = () =>
  adminHttpCommon.get("admin-dashboard/franchises/stats/");

export const fetchAdminFranchises = ({ page = 1, pageSize = 20, search = "" }) =>
  adminHttpCommon.get("admin-dashboard/franchises/", {
    params: removeEmptyParams({ page, page_size: pageSize, search }),
  });

export const createAdminFranchise = (payload) =>
  adminHttpCommon.post("admin-dashboard/franchises/", payload);

export const fetchAdminFranchise = (franchiseId) =>
  adminHttpCommon.get(`admin-dashboard/franchises/${franchiseId}/`);

export const updateAdminFranchise = (franchiseId, payload) =>
  adminHttpCommon.patch(`admin-dashboard/franchises/${franchiseId}/`, payload);

export const deleteAdminFranchise = (franchiseId) =>
  adminHttpCommon.delete(`admin-dashboard/franchises/${franchiseId}/`);

export const fetchAdminSchoolStats = () => {
  return adminHttpCommon.get("admin-dashboard/schools/stats/");
};

export const fetchAdminSchoolFilters = () => {
  return adminHttpCommon.get("admin-dashboard/schools/filters/");
};

export const fetchAdminSchools = ({
  page = 1,
  pageSize = 20,
  search = "",
  filters = {},
}) => {
  return adminHttpCommon.get("admin-dashboard/schools/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
      city: filters.city || "",
      pincode: filters.pincode || "",
      board: filters.board || "",
      status: filters.status || "",
    }),
  });
};

export const createAdminSchool = (payload) => {
  return adminHttpCommon.post("admin-dashboard/schools/", payload);
};

export const updateAdminSchool = (schoolId, payload) => {
  return adminHttpCommon.patch(`admin-dashboard/schools/${schoolId}/`, payload);
};

export const deleteAdminSchool = (schoolId) => {
  return adminHttpCommon.delete(`admin-dashboard/schools/${schoolId}/`);
};
